import { useCommentsSection } from "@/react/components/CommentsCompass/Provider/SectionContext";

export const useReplyComposerFocus = (commentId: number) => {
  const { matchReplyFocusTarget, clearComposerFocusRequest } =
    useCommentsSection();
  const target = matchReplyFocusTarget(commentId);

  return {
    isFocusPending: target !== null,
    mentionCommunityMember: target?.mentionCommunityMember ?? null,
    onFocusHandled: clearComposerFocusRequest,
  };
};
